import { useBacklogSelector } from '../../index';
import { getIsCompanyManaged } from '../../selectors/app';
import { canEditBoardConfig } from '../../selectors/permissions';

// only eligible to the experiment if it is
// JSW TMP Project, users can edit the board
// there is no check for JSW Project here since backlog is only for JSW
// https://atlassian.slack.com/archives/C05SLGLGCKS/p1710739453010399
export const useIsEligibleForConfigInContextIssueTypes = () => {
	const isCompanyManaged = useBacklogSelector(getIsCompanyManaged);
	const canEditBoard = useBacklogSelector(canEditBoardConfig);

	return !isCompanyManaged && canEditBoard;
};
